/**
 * ブラウザのビューポート（表示領域）の高さをピクセル単位で取得します。
 * この高さは、スクロールバーの高さを含まない、実際にコンテンツが表示される領域の高さです。
 *
 * @returns {number} ウィンドウの高さをピクセル単位で返します。
 */
export function getPageHeight() {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;
}
